var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_1212)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6C2 9.33593 4.66667 13.3333 8 15.9995C11.3333 13.3333 14 9.3137 14 6C14 2.68629 11.3137 0 8 0C4.6863 0 2 2.68629 2 6ZM8 0.666667C10.9455 0.666667 13.3333 3.05448 13.3333 6C13.3333 8.8111 11.1474 12.4642 7.99993 15.1358C4.8438 12.4588 2.66667 8.8251 2.66667 6C2.66667 3.05448 5.05447 0.666667 8 0.666667ZM8 8.66667C6.52723 8.66667 5.33333 7.47277 5.33333 6C5.33333 4.52723 6.52723 3.33333 8 3.33333C9.47277 3.33333 10.6667 4.52723 10.6667 6C10.6667 7.47277 9.47277 8.66667 8 8.66667ZM10 6C10 7.10457 9.10457 8 8 8C6.89543 8 6 7.10457 6 6C6 4.89543 6.89543 4 8 4C9.10457 4 10 4.89543 10 6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_104_1212",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 12,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6C2 9.33593 4.66667 13.3333 8 15.9995C11.3333 13.3333 14 9.3137 14 6C14 2.68629 11.3137 0 8 0C4.6863 0 2 2.68629 2 6ZM8 0.666667C10.9455 0.666667 13.3333 3.05448 13.3333 6C13.3333 8.8111 11.1474 12.4642 7.99993 15.1358C4.8438 12.4588 2.66667 8.8251 2.66667 6C2.66667 3.05448 5.05447 0.666667 8 0.666667ZM8 8.66667C6.52723 8.66667 5.33333 7.47277 5.33333 6C5.33333 4.52723 6.52723 3.33333 8 3.33333C9.47277 3.33333 10.6667 4.52723 10.6667 6C10.6667 7.47277 9.47277 8.66667 8 8.66667ZM10 6C10 7.10457 9.10457 8 8 8C6.89543 8 6 7.10457 6 6C6 4.89543 6.89543 4 8 4C9.10457 4 10 4.89543 10 6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_104_1212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V16H16V0Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_1212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.31a19adf09acb1effab3e2b8e1d570b4.svg";
export { ForwardRef as ReactComponent };